import React from "react";
import { DivisorPeB } from "../divisor";
import { IProperty } from "../../../../shared/interfaces/IProperties";

interface IDisclaimerProps {
    property?: IProperty;
}

export const DisclaimerAraucaria: React.FC<IDisclaimerProps> = ({ property }) => {
    return (
        <div>
            <div className="text-justify text-center">
                <h5>CONSULTA PRÉVIA PARA VIABILIDADE DE CONSTRUÇÃO</h5>
                <p>
                    A Consulta para Construção é um documento emitido pela
                    Prefeitura do Município de Araucária onde constam as
                    informações sobre os usos e parâmetros construtivos para
                    determinado lote. As informações aqui contidas são de
                    caráter preliminar e não substituem a legislação vigente e
                    não se encerram em si mesmas, sendo obrigatório o
                    cumprimento de toda a legislação pertinente, citada ou não.
                    (Lei Complementar 26/2020, Arts 24 e 25)
                </p>
            </div>
            <DivisorPeB />
            <div className="text-justify text-center">
                <p>
                    OS ÓRGÃOS COMPETENTES DEVERÃO SER CONSULTADOS EM RELAÇÃO ÀS
                    DIRETRIZES DO SISTEMA VIÁRIO, ÁREAS DE PRESERVAÇÃO
                    PERMANENTE E FAIXAS DE SERVIDÃO
                </p>
            </div>
            {property?.tombamento_texto && (
                <div
                    className="text-center"
                    style={{
                        color: "red",
                        border: "2px solid red",
                        padding: "5px",
                        marginTop: "10px",
                        fontWeight: "bold",
                    }}
                >
                    {property.tombamento_texto}
                </div>
            )}
            <DivisorPeB />
        </div>
    );
};
